import { IMessagingEvent } from './model';

export const dispatchMessage = <T>(message: IMessagingEvent<T>) =>
  document.dispatchEvent(new CustomEvent<T>(message.event, { detail: message.payload }));

export const dispatchEcommerceMessage = <T>(customEvent: CustomEvent<T>) => document.dispatchEvent(customEvent);
